import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Brand = ({ content }) => {

    return (
        <Chip id="260868" title="权益图片" groupName="中国力量" type="struct">
            <div>
                {content.map((item, index) => {
                    return (
                        <div key={index} className={styles.brand}>
                            {item.url ? (
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    <img src={item.imageUrl} />
                                </a>
                            ) : (
                                <img src={item.imageUrl} />
                            )}
                        </div>
                    );
                })}
            </div>
        </Chip>
    );
};

Brand.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Brand);
